import { debug } from "aaa";
import { action, computed, observable } from "mobx";
import { create, persist } from "mobx-persist";
import { pushRoute } from "./RouterFunctions";
import { history } from "./RouterStore";
import { SupportedLocales, config } from "config";

export class AuthStore {
    @observable isRehydrated = false;

    handleForbidden = true;
    handleUnauthorized = true;

    // accessToken gets set externally by the ExternalInterfaceStore
    @persist @observable accessToken?: string = undefined;

    @computed
    get authorized() {
        return !!this.accessToken;
    }

    @observable _locale: SupportedLocales = "de";

    get locale() {
        return this._locale;
    }

    set locale(newLocale: SupportedLocales) {
        // For debugging strange locale changes
        // debug.log(`### setting locale ${this._locale} to ${newLocale}`);
        this._locale = newLocale;
    }

    @action showErrorPage(errorRoute: string) {
        this.logout();
        if (history.location.pathname !== errorRoute) {
            pushRoute(errorRoute);
        }
    }

    @action logout() {
        this.accessToken = undefined;
    }

    // unauthorized user
    @action unauthorized(): void {
        debug.log("### handleUnauthorized", this.handleUnauthorized);
        if (this.handleUnauthorized) {
            this.showErrorPage("/unauthorized");
        }
    }

    // forbidden user
    @action forbidden(): void {
        debug.log("### handleForbidden", this.handleForbidden);
        if (this.handleForbidden) {
            this.showErrorPage("/forbidden");
        }
    }
}

// persist this mobx state through localforage
const hydrate = create({
    // storage: require("localforage"),
});
const authStore = new AuthStore();

hydrate("AuthStore", authStore)
    .then(() => {
        debug.log("### AuthStore rehydrated", authStore.accessToken);
        authStore.isRehydrated = true;
    })
    .catch((error: any) => {
        console.error(error);
    });

export default authStore;




// WEBPACK FOOTER //
// ./src/stores/AuthStore.ts